export class UserPruBE {
    Id: number =-1;
    PruId: number = -1;
    UserId: string = "";
    UserName: string = "";
    IsApprover: boolean = false;    
}



// WEBPACK FOOTER //
// C:/Users/PBABH7/Workspace/OnPremChina/PackITWebGui/src/app/user-management/shared/user-management.model.ts